import notify from 'devextreme/ui/notify';

export async function notificaMessaggio(strErr:string, tipo:string) {
  const position: any = 'bottom right';
  const direction: any = 'up-stack';

  notify({
    message: strErr,
    height: 50,
    width: 350,
    minWidth: 150,
    type: tipo,
    displayTime: 4000,
    animation: {
      show: {
        type: 'fade', duration: 400, from: 0, to: 1,
      },
      hide: { type: 'fade', duration: 40, to: 0 },
    },
  }, 
  { position, direction });
}